import React from "react";
import { FormattedMessage } from "react-intl";
export const EmsTypeColumnFormatter = (cellContent, row) => (
  <span

    className={`text-${ObjectCssClasses[((row.type === "Golestan" || row.type === "1") ? 0 : 1)]}`}
  >
    <FormattedMessage id={ObjectTitles[((row.type === "Golestan" || row.type === "1") ? 0 : 1)]} />
  </span>
);


export const ObjectCssClasses = ["success", "info"];
export const ObjectTitles = ["MODULES.BASEINFO.EMS.SETTING.TYPE1", "MODULES.BASEINFO.EMS.SETTING.TYPE2"];